import React from 'react';
import { Grid, Skeleton, styled } from '@mui/material';
import { Breadcrumbs, TitleBar } from '@/components/_common';
import { Link } from 'react-router-dom';
import Refresh from '@/components/_common/Refresh';

interface Props {
  isLoading: boolean;
  displayedItemTitle?: string;
  loadScheduleDetails: () => void;
}

const AvailScheduleDetailsBreadcrumbs: React.FC<Props> = (props) => {
  const { loadScheduleDetails } = props;
  return (
    <TitleBarStyled>
      <Grid container justifyContent="space-between" alignItems="center">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/focus/schedule">Schedule</Link>
          {props.isLoading ? <Skeleton variant="text" width={100} /> : <span>{props.displayedItemTitle}</span>}
        </Breadcrumbs>
        <Refresh onClick={loadScheduleDetails} />
      </Grid>
    </TitleBarStyled>
  );
};

export default AvailScheduleDetailsBreadcrumbs;

const TitleBarStyled = styled(TitleBar)`
  // have to bump specificity because TitleBar already does it and I want to override its' styles
  && {
    margin-bottom: 0;
  }
`;
